import React, {useState} from "react";
import {Box, Button, Container, Flex, Heading, SimpleGrid, Stack, Text} from "@chakra-ui/react";
import {PhoneIcon} from "@chakra-ui/icons";
import {categoryUrl, imageUrl} from "../data/catalog";
import {site} from "../data/site";
import {Breadcrumbs} from "../components/PageBanner";
import SectionHeading from "../components/SectionHeading";
import SubCategoryCard from "../components/SubCategoryCard";
import PhotoMasonry from "../components/PhotoMasonry";
import Lightbox from "../components/Lightbox";
import {useQuote} from "../components/QuoteContext";
import usePageTitle from "../usePageTitle";

function SubCategoryPage({category, sub}) {
    usePageTitle(sub.description);
    const {openQuote} = useQuote();
    const [open, setOpen] = useState(null);

    const photos = sub.img_urls.map(imageUrl);
    const items = photos.map((src) => ({type: "image", src, title: sub.description, subtitle: category.title}));
    const siblings = category.content.filter((s) => s !== sub);

    return (
        <>
            <Box bg="ink.50" borderBottom="1px solid" borderColor="ink.100">
                <Container maxW="container.xl" py={{base: 8, md: 12}}>
                    <Breadcrumbs crumbs={[
                        {label: "Home", to: "/"},
                        {label: category.title, to: categoryUrl(category)},
                        {label: sub.description},
                    ]}/>
                    <Flex direction={{base: "column", md: "row"}} justify="space-between" align={{base: "start", md: "end"}} gap={6} mt={6}>
                        <Box>
                            <Text textTransform="uppercase" letterSpacing="0.2em" fontSize="xs" fontWeight={700} color="brand.500">
                                {category.title}
                            </Text>
                            <Heading as="h1" fontSize={{base: "2xl", md: "4xl"}} textTransform="uppercase" letterSpacing="0.02em"
                                     lineHeight={1.15} mt={3} maxW="3xl">
                                {sub.description}
                            </Heading>
                            <Text mt={3} color="ink.500">{photos.length} {photos.length === 1 ? "photo" : "photos"}</Text>
                        </Box>
                        <Stack direction={{base: "column", sm: "row"}} spacing={3} flexShrink={0} w={{base: "100%", sm: "auto"}}>
                            <Button onClick={() => openQuote(category.title)}>Get a free quote</Button>
                            <Button as="a" href={site.phoneHref} variant="outline" colorScheme="gray" borderColor="ink.800"
                                    leftIcon={<PhoneIcon/>}>
                                {site.phone}
                            </Button>
                        </Stack>
                    </Flex>
                </Container>
            </Box>

            <Container maxW="container.xl" py={{base: 10, md: 16}}>
                <PhotoMasonry photos={photos} alt={sub.description} onOpen={setOpen}/>
            </Container>

            {siblings.length > 0 && (
                <Box as="section" py={{base: 12, md: 20}} bg="ink.50">
                    <Container maxW="container.xl">
                        <SectionHeading eyebrow={category.title} title="More styles" align="left" mb={8}/>
                        <SimpleGrid columns={{base: 1, sm: 2, lg: 4}} spacing={6}>
                            {siblings.map((s) => <SubCategoryCard key={s.path} category={category} sub={s}/>)}
                        </SimpleGrid>
                    </Container>
                </Box>
            )}

            <Lightbox items={items} index={open} onClose={() => setOpen(null)} onChange={setOpen}/>
        </>
    );
}

export default SubCategoryPage;
